import React from 'react';
import { Box, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import { ADD_MESSAGE } from 'constants/routes';
import withBreadcrumbs from 'hocs/withBreadcrumbs';
import MessagesTable from './table';
import useStyles from '../style';

const Messages: React.FC<{}> = () => {
  const classes = useStyles();

  return (
    <div>
      <Box className={classes.topContent}>
        <Link to={ADD_MESSAGE}>
          <Button className={classes.addButton}>
            <Typography variant='h6'>Add New</Typography>
            <AddIcon />
          </Button>
        </Link>
      </Box>
      <MessagesTable />
    </div>
  );
};

export default withBreadcrumbs(Messages);
